import type { useTranslations } from "@i18n/next";

export const renderUnknownError = (
  e: any,
  t: ReturnType<typeof useTranslations>,
) =>
  e?.error?.message ??
  e?.message ??
  e?.error ??
  (typeof e === "string" ? e : t("general_error_message"));
